import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mor-panel" }
const _hoisted_2 = { class: "mor-filters" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "mor-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "mor-empty"
}
const _hoisted_6 = {
  key: 2,
  class: "mor-list"
}
const _hoisted_7 = { class: "mor-type-title" }
const _hoisted_8 = { class: "mor-instances" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "mor-instance-number" }
const _hoisted_11 = { class: "mor-instance-meta" }
const _hoisted_12 = { class: "mor-instance-meta" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaintenanceOSInstanceDetail = _resolveComponent("MaintenanceOSInstanceDetail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selectedOsId)
      ? (_openBlock(), _createBlock(_component_MaintenanceOSInstanceDetail, {
          key: 0,
          "os-id": _ctx.selectedOsId,
          "access-level": _ctx.accessLevel,
          onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedOsId = '')),
          onChanged: _ctx.reload
        }, null, 8, ["os-id", "access-level", "onChanged"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("select", {
              class: "mor-select",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.projectId) = $event)),
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("option", { value: "" }, "Todos os projetos", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: p.id,
                  value: p.id
                }, _toDisplayString(p.name), 9, _hoisted_3))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.filters.projectId]
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "mor-select",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.status) = $event)),
              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("option", { value: "" }, "Todos os status", -1),
              _createElementVNode("option", { value: "pending" }, "Em andamento", -1),
              _createElementVNode("option", { value: "approved" }, "Aprovadas", -1),
              _createElementVNode("option", { value: "cancelled" }, "Canceladas", -1)
            ]))], 544), [
              [_vModelSelect, _ctx.filters.status]
            ]),
            (_ctx.accessLevel >= 3)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "mor-btn mor-btn-primary",
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.exportExcel && _ctx.exportExcel(...args)))
                }, "Exportar Excel"))
              : _createCommentVNode("", true)
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Carregando..."))
            : (_ctx.typeGroups.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Nenhuma OS encontrada."))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeGroups, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.rootId,
                      class: "mor-type-card"
                    }, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(group.title), 1),
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.instances, (inst) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: inst.id,
                            class: "mor-instance-row",
                            type: "button",
                            onClick: ($event: any) => (_ctx.selectedOsId = inst.id)
                          }, [
                            _createElementVNode("span", _hoisted_10, "OS" + _toDisplayString(inst.osNumber), 1),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(inst.projectName) + " · " + _toDisplayString(inst.responsaveis.join(', ')), 1),
                            _createElementVNode("span", _hoisted_12, _toDisplayString(inst.lastCompletedAt ? `preenchida em ${_ctx.formatDateTime(inst.lastCompletedAt)}${inst.lastCompletedByName ? ' por ' + inst.lastCompletedByName : ''}` : 'não preenchida'), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass(["mor-status-badge", 's-' + inst.status])
                            }, _toDisplayString(_ctx.statusLabel(inst.status)), 3)
                          ], 8, _hoisted_9))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]))
        ], 64))
  ]))
}